function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.22 14.62c0 3.225 2.597 5.84 5.802 5.84 3.204 0 5.801-2.615 5.801-5.84 0-3.01-2.262-5.488-5.169-5.805-.138-.015-1.363.71-3.675 2.175l-2.76 3.63z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.933 33.354c1.142-2.125 1.59-3.774 1.346-4.948-.244-1.174.648-1.29 2.676-.347-.054 2.65-.208 4.028-.465 4.13-.256.103-1.442.491-3.557 1.165z",
  stroke: "#371447",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.432 75.757c.016-.403-.092-.603-.246-.859-6.536-10.794-17.41-13.567-25.044-17.544-5.103-2.658-8.634-5.98-10.59-9.965a9.736 9.736 0 00.426-2.796 12.46 12.46 0 00-6.197-10.777c-1.644-2.6-4.939-6.582-6.668-7.213-1.729-.63-.76 2.957-1.593 5.682a12.484 12.484 0 00-9.931 8.643c-.29.94-.47 1.928-.528 2.948-1.339.832-2.489 1.897-3.027 2.529-.487.572-.795 1.014-.795 2.247 0 3.715 3.634 6.206 9.492 6.332a14.49 14.49 0 001.646-.044 21.401 21.401 0 002.99 1.447c-2 5.811-1.728 12.245.652 18.335.225.578.528 1.17.527 1.689 2.887-2.03 9.462-1.552 19.724 1.431s19.983 2.288 29.162-2.085z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.432 75.757c.016-.403-.092-.603-.246-.859-6.536-10.794-17.41-13.567-25.044-17.544-5.103-2.658-8.634-5.98-10.59-9.965a9.736 9.736 0 00.426-2.796 12.46 12.46 0 00-6.197-10.777c-1.644-2.6-4.939-6.582-6.668-7.213-1.729-.63-.76 2.957-1.593 5.682a12.484 12.484 0 00-9.931 8.643c-.29.94-.47 1.928-.528 2.948-1.339.832-2.489 1.897-3.027 2.529-.487.572-.795 1.014-.795 2.247 0 3.715 3.634 6.206 9.492 6.332a14.49 14.49 0 001.646-.044 21.401 21.401 0 002.99 1.447c-2 5.811-1.728 12.245.652 18.335.225.578.528 1.17.527 1.689",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#FFB74D",
  cx: 21.076,
  cy: 58.43,
  rx: 1.882,
  ry: 1.894
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 13.236,
  cy: 43.911,
  rx: 1.254,
  ry: 1.263
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.204 48.978c.706 0 2.073-.91 2.073-1.649 0-.738-1.21-1.209-1.916-1.209-.707 0-1.28.599-1.28 1.338 0 .738.417 1.52 1.123 1.52z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.425 74.874c5.627-9.469 7.217-21.645 1.145-38.374a55.714 55.714 0 00-1.547-3.838c-1.257-3.712-2.793-7.546-4.552-11.07a10.7 10.7 0 00.147-1.77c0-2.923-1.183-5.594-3.138-7.642C63.65 5.747 56.682-.69 56.306.864c-.353 1.46-.081 3.429-2.254 7.47a14.225 14.225 0 00-2.298-.186c-5.204 0-9.687 2.805-11.713 6.84-6.605-.352-11.158.119-13.658 1.413-1.247.583-3.204 7.996 4.151 11.599 4.716 2.043 4.884.049 12.955 0 .66.502 1.523 1.197 2.137 2.088 6.693 11.028 2.39 17.943-12.907 20.745C17.354 53.647 8.375 61.968 5.782 75.796l-.028.928",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.99 35.864C64.8 38.848 61 40.4 58.586 40.519c-2.414.12-5.515-.44-10.17-1.943",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 45.29,
  cy: 15.742,
  rx: 1.254,
  ry: 1.263
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#FFB74D",
  cx: 58.882,
  cy: 42.894,
  rx: 1.882,
  ry: 1.894
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.344 20.055c.983 0 2.886-1.211 2.886-2.195 0-.983-1.685-1.61-2.668-1.61-.984 0-1.781.798-1.781 1.781 0 .984.579 2.024 1.563 2.024z",
  fill: "#371447"
}));

function SvgPetsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPetsLg;